export const KEY_LABELS = {
  timestamp: "Last Updated at",
  teacherId: "Teacher ID",
  appVersion: "App Version",
  deviceId: "Device ID",
  triggeredFrom: "Update Stage",
  totalResources: "Total Resources",
  redResources: "Red Resources",
  teacherTotalResources: "Teacher Total Resources",
  teacherRedResources: "Teacher Red Resources",
  contentPersistenceRunAt: "Persistence Run@",
  oneClickRunAt: "One Click Run@",
  canManageExternalStorage: "Ext. Storage Permission",
  developerOptionEnabled: "Developer Option",
  wifiName: "Wi-Fi Name",
  sdCardSerialNumber: "SD Card Serial Number",
  sdCardProfileName: "SD Card Profile Name",
  sdCardVersion: "SD Card Version",
  sdCardUpdatedDate: "SD Card Updated Date",
  preparedDate: "Prepared Date",
  isNasEnabled: "NAS",
  mdmDeviceId: "TPS Device ID",
  isLocked: "Is Locked",
  enrolledTime: "Enrolled Time",
  totalExternalStorage: "SD Card Size",
  availableExternalStorage: "Free Space in SD",
  availableInternalStorage: "Available Internal Storage",
  availableBattery: "Available Battery",
  role: "Role",
  deviceType: "Device Type",
  schoolId: "School ID",
  nasIpLastConnected: "NAS IP",
  lastTimestamp: "Last Timestamp",
  realmSize: "Realm Size",
  tabModel: "Tab Model",
  pendingActions: "Pending Actions",
  troubleshoot: "TroubleShoot",
  otpExpiredTime: "OTP Expire Time:",
  otpCode: "OTP Code:",
  attempts: "Attempts Left:",
  sdCardErrorMessage: "SD Card OK"
};

export const TABLE_HEADERS = {
  recievedAt: "Recieved At",
  appVersion: "App Version",
  details: "Details",
  deviceId: "Device Id",
  event: "Event",
  hasNas: "Has NAS",
  ip: "IP Address",
  wifi: "Wifi Status",
};

export const TROUBLESHOOT_STEPS = {
  resourceNotFound: [
    "Is the TA credential active in system?",
    "Is NAS Box present in the school?",
    "Is NAS box on?",
    "Does NAS have all the resources downloaded?",
    "Is Wifi Router on?",
    "Is the teacher connected to LEAD AP Wifi?",
    "Does the teacher have the correct class and subjects assigned?",
    "Has the teacher downloaded all the resources?",
    "Does the TAB have a SD card?",
    "Is TAB SD Card storage full?",
    "Is TAB updated to the latest version?",
    "When was the last time resources were downloaded from NAS?",
    "Internet connection and speed?",
  ],
};

export const TROUBLESHOOT_SELECT_DATA = [
  {
    issue: "Resource not found",
    id: "resourceNotFound",
  },
];
